/* eslint-disable flowtype/require-valid-file-annotation */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Clear from 'material-ui-icons/Clear'
import { FormControl } from 'material-ui/Form'
import IconButton from 'material-ui/IconButton'
import Input, { InputLabel } from 'material-ui/Input'
import Mail from 'material-ui-icons/Mail'
import { MenuItem } from 'material-ui/Menu'
import Messages from '../constants/messages'
import ModeEdit from 'material-ui-icons/ModeEdit'
import moment from 'moment'
import { nordAdmins, partnerAccessAdmin } from '../constants/memberships'
import Paper from 'material-ui/Paper'
import PersonAdd from 'material-ui-icons/PersonAdd'
import SearchIcon from 'material-ui-icons/Search'
import Select from 'material-ui/Select'
import Table, {
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow } from 'material-ui/Table'
import TextField from 'material-ui/TextField'
import Tooltip from 'material-ui/Tooltip'
import { toTitleCase, hasRole, hasMembership } from '../utils/helpers'
import withStyles from 'material-ui/styles/withStyles'

const PROP_TYPES = {
  data: PropTypes.array.isRequired,
  fetchDataCallback: PropTypes.func,
  paginationChangePage: PropTypes.func.isRequired,
  paginationChangeRowsPerPage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  search: PropTypes.bool,
  searchFieldLabel: PropTypes.string,
  searchOnChange: PropTypes.func,
  searchValue: PropTypes.string,
  serverSidePagination: PropTypes.bool,
  tableOptions: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    friendlyName: PropTypes.string.isRequired,
    displayType: PropTypes.string.isRequired,
    callback: PropTypes.func })
  ).isRequired,
  tableButtons: PropTypes.arrayOf(PropTypes.shape({
      buttonName: PropTypes.string.isRequired,
      callback: PropTypes.func.isRequired })
  ),
  totalCount: PropTypes.number
}

const styles = theme => ({
  actions: {
    whiteSpace: 'nowrap',
    display:'flex',
    'justify-content': 'flex-end'
  },
  paper: {
    width: '100%',
    overflowX: 'auto',
  },
  header: {
    fontSize: 18
  },
  formControl: {
    margin: '1%',
    minWidth: '20%',
    maxWidth: '40%'
  },
  link: {
    cursor: 'pointer'
  },
  center: {
    textAlign: 'center'
  },
  notSelected: {
    backgroundColor: "none", //Overides for deselecting in multiselect menuItems
    '&:focus': {
      background: "none",
    }
  },
  rowsSelect: {
    marginTop: 4
  },
  search: {
    margin: '10px 0 10px 35px',
    minWidth: '20%',
    maxWidth: '50%'
  },
  searchField: {
    width: '55%'
  },
  searchIcon: {
    verticalAlign: 'middle',
    color: 'gray'
  },
  tableBody: {
    whiteSpace: 'nowrap'
  },
  wrap: {
    width: '20%',
    whiteSpace: 'normal'
  }
})

export class TableDisplay extends Component {

  handleChangePage = (page) => {
    const {
      fetchDataCallback,
      paginationChangePage,
      serverSidePagination,
      type } = this.props

    paginationChangePage(type, page).then(() => {
      if(serverSidePagination) {
        fetchDataCallback(true)
      }
    })
  }

  handleChangeRowsPerPage = (event) => {
    const {
      fetchDataCallback,
      paginationChangeRowsPerPage,
      serverSidePagination,
      type } = this.props

    paginationChangeRowsPerPage(type, event.target.value).then(() => {
      if(serverSidePagination) {
        fetchDataCallback(true)
      }
    })
  }

  roleUsingPermission = (permission, roles) => {
    for (var i = 0; i < roles.length; i++) {
      if (roles[i].permissions.some(perm => perm === permission.id)) {
        return true
      }
    }
    return false
  }

  renderButton(button, item) {
    const { authProfile, tab, roles } = this.props
    switch(button.buttonName) {
      case 'PersonAdd':
        return (
          <Tooltip id="tooltip-icon" title={button.tooltip} placement="bottom">
            <IconButton id="add-icon-button" onClick={() => button.callback(item)}><PersonAdd /></IconButton>
          </Tooltip>
        )
      case 'ModeEdit':
        if (tab === 'permission' && roles) {
          if (this.roleUsingPermission(item, roles)) {
            return (
              <Tooltip id="tooltip-icon" title={`${Messages['tooltips']['EDIT_PERMISSION_DISABLED']}`} placement="bottom">
                <div>
                  <IconButton disabled={true} id="edit-icon-button" onClick={() => button.callback(item)}><ModeEdit /></IconButton>
                </div>
              </Tooltip>
            )
          }
        }
        return (
          <Tooltip id="tooltip-icon" title={`${button.tooltip} ${tab}`} placement="bottom">
            <IconButton id="edit-icon-button" onClick={() => button.callback(item)}><ModeEdit /></IconButton>
          </Tooltip>
        )
      case 'Clear':
        if (tab === 'permission' && roles) {
          if (this.roleUsingPermission(item, roles)) {
            return (
              <Tooltip id="tooltip-icon" title={`${Messages['tooltips']['DELETE_PERMISSION_DISABLED']}`} placement="bottom">
                <div>
                  <IconButton disabled={true} id="delete-icon-button" onClick={() => button.callback(item)}><Clear /></IconButton>
                </div>
              </Tooltip>
            )
          }
        } else if (tab === 'group' && authProfile && !hasMembership(authProfile.userMemberships, nordAdmins)) {
          let disableRemoveUser = authProfile.groups.filter((group) => group.name === item.name && group.roles.find((role) => role.name.toLowerCase() === 'partneraccessadmin')).length === 0

          return (
            <Tooltip id="tooltip-icon" title={`${button.tooltip} ${tab}`} placement="bottom">
              <IconButton id="delete-icon-button" disabled={disableRemoveUser} onClick={() => button.callback(item)}><Clear /></IconButton>
            </Tooltip>
          )
        } else if (tab === 'user' && authProfile && hasRole(authProfile.userRoles, partnerAccessAdmin)) {
          // NID-1510 - Don't allow Vendor admins to delete users from users view.
          return null
        }
        return (
          <Tooltip id="tooltip-icon" title={`${button.tooltip} ${tab}`} placement="bottom">
            <IconButton id="delete-icon-button" onClick={() => button.callback(item)}><Clear /></IconButton>
          </Tooltip>
        )
      case 'Email':
        let tooltip = item.emailVerified ?
          Messages['tooltips']['CHANGE_PASSWORD_EMAIL'] : Messages['tooltips']['INVITATION_EMAIL']
        return (
          <Tooltip id="tooltip-icon" title={tooltip} placement="bottom">
            <IconButton onClick={() => button.callback(item)}><Mail /></IconButton>
          </Tooltip>
        )
      default:
        return null
    }
  }

  renderFilter() {
    const { classes, filter, filtered, setFilter } = this.props
    const selectedClass = (id) =>  {
      return Array.isArray(filter) && filter.indexOf(id) === -1 ?
      classes.notSelected : null
    }
    let markup = null
    if (filtered) {
      markup = (
        <FormControl className={classes.formControl} id="partnerFilter">
          <InputLabel htmlFor="partner">{Messages['uiComponents']['TABLE_PARTNER_NAME_COLUMN']}</InputLabel>
          <Select
            value={filter}
            multiple
            onChange={e => setFilter(e.target.value)}
            input={<Input id="partner" />}>
            <MenuItem disabled value="">
              <em>Filter</em>
            </MenuItem>
             {filtered.map(partner => (
              <MenuItem key={partner.id} value={partner.id} className={selectedClass(partner.id)}>
                {partner.name.toUpperCase()}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )
    }
    return markup
  }

  renderSearchField() {
    const {
      classes,
      fetchDataCallback,
      paginationChangePage,
      search,
      searchFieldLabel,
      searchOnChange,
      searchValue,
      type } = this.props
    let markup = null

    if (search) {
      markup = (
        <div className={classes.search}>
          <SearchIcon className={classes.searchIcon} />
          <TextField
            label={searchFieldLabel}
            type="search"
            className={classes.searchField}
            onChange={(ev) => searchOnChange(type, ev.target.value)}
            onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                paginationChangePage(type, 0).then(() => {
                  fetchDataCallback(true)
                })
              }
            }}
            value={searchValue} />
        </div>
      )
    }

    return markup
  }

  renderTableBody() {
    const {
      classes,
      data,
      filter,
      filtered,
      page,
      rowsPerPage,
      serverSidePagination,
      tableOptions,
      tableButtons } = this.props
    let markup = null
    if (data && tableOptions) {
      // Render the table options (headers, type, etc) and corresponding data
      let markupData = data
      if (filtered && filter.length > 0) {
        markupData = data.filter((user) => user.partners.some(partner => filter.includes(partner.id)))
      }
      if (!serverSidePagination) {
        markupData = markupData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      }
      markup = markupData.map((item, index) => {
        return (
          <TableRow key={index} hover>
            {
              tableOptions.map((prop, index) => {
                if(typeof item[prop.name] !== 'undefined')
                  switch(prop.displayType) {
                    case 'commaSeparated':
                      return <TableCell className={classes.wrap} key={index}>{item[prop.name].map(partner => partner.name).join(', ').toUpperCase()}</TableCell>
                    case 'commaSeparatedId':
                      return <TableCell key={index} className={classes.wrap}>{item[prop.name].map(partner => partner.id).join(', ')}</TableCell>
                    case 'count':
                      return <TableCell key={index} className={`${classes.center} ${classes.wrap}`}>{item[prop.name].length}</TableCell>
                    case 'link':
                      return <TableCell className={classes.link} key={index} onClick={() => prop.callback(item)}>{item.isAdmin ? item[prop.name] + ' (Admin)' : item[prop.name]}</TableCell>
                    case 'string':
                      return <TableCell className={classes.wrap} key={index}>{item[prop.name]}</TableCell>
                    case 'stringNested':
                      return <TableCell className={classes.wrap} key={index}>{item[prop.name]['name'].toUpperCase()}</TableCell>
                    case 'id':
                      return <TableCell className={classes.wrap} key={index}>{item[prop.name]['id']}</TableCell>
                    case 'dateFrom':
                      return <TableCell className={classes.wrap} key={index}>{moment(item[prop.name]).from()}</TableCell>
                    case 'verified':
                      return <TableCell className={classes.wrap} key={index}>{toTitleCase(item[prop.name])}</TableCell>
                    default:
                      return null
                } else {
                  return <TableCell key={index}></TableCell>
                }
              })
            }
            {
              tableButtons ?
                <TableCell>
                  <span className={classes.actions}>
                    {
                      tableButtons.map((button,index) => {
                        return (
                          <span key={tableOptions.length + index}>
                            {this.renderButton(button, item)}
                          </span>
                        )
                      })
                    }
                  </span>
                </TableCell>
              : null
            }
          </TableRow>
        )
      })
    }
    return markup
  }

  renderTableHeaders() {
    const { classes, tableOptions, tableButtons } = this.props
    let markup = null
    if (tableOptions) {
      markup = tableOptions.map((prop, index) => {
        return <TableCell key={index} className={prop.displayType === 'count' ? classes.center : ''}>{prop.friendlyName}</TableCell>
      })
      if (tableButtons) {
        // If there should be buttons, make room for them within headers here
        markup = markup.concat((<TableCell key={Math.floor(Math.random()*(999 - 100)+100)} />))
      }
    }
    return markup
  }

  render() {
    const {
      classes,
      page,
      rowsPerPage,
      totalCount } = this.props
    return (
      <Paper className={classes.paper}>
        <section>
          {this.renderFilter()}
          {this.renderSearchField()}
        </section>
        <Table>
          <TableHead className={classes.header}>
            <TableRow>
              {this.renderTableHeaders()}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody} id='table-display-table-body'>
            {this.renderTableBody()}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                classes={{
                  select: classes.rowsSelect
                }}
                colSpan={0}
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onChangePage={(event, page) => this.handleChangePage(page)}
                onChangeRowsPerPage={(event) => this.handleChangeRowsPerPage(event)}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    )
  }
}

TableDisplay.propTypes = PROP_TYPES

export default withStyles(styles)(TableDisplay)
